import { Component, OnInit } from '@angular/core';

import { VeiculoService } from '../../../services/veiculo.service';
import { AuthService } from '../../../services/auth.service';
@Component({
  selector: 'app-veiculosprint',
  templateUrl: './veiculosprint.component.html',
  styleUrls: ['./veiculosprint.component.css']
})
export class VeiculosprintComponent implements OnInit {

  public veiculos = [];

  constructor(
    private authSvc: AuthService,
    private veiculoSvc: VeiculoService
    ) { }

  ngOnInit() {
    this.pegaVeiculos(this.authSvc.getUsuarioId());

  }

  pegaVeiculos(usuario_id) {
    this.veiculoSvc.getRelatorioVeiculos(usuario_id).then((data: any) => {
      this.veiculos = data;
    }).catch((err) => console.log(err));
  }


}
